/**
 * Piletilevi Sales terminal services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * all possible paymentTypes in the system, currently in a weird spot in the system it seems tha payment method really should take over at some point as the main decider
 */
export type PaymentTypeEnum = 'cash' | 'card' | 'transfer' | 'gift_card' | 'no_payment';

export const PaymentTypeEnum = {
    Cash: 'cash' as PaymentTypeEnum,
    Card: 'card' as PaymentTypeEnum,
    Transfer: 'transfer' as PaymentTypeEnum,
    GiftCard: 'gift_card' as PaymentTypeEnum,
    NoPayment: 'no_payment' as PaymentTypeEnum
};

